export function decodeTonConnectStartAppParams(encodedParameters: string): string {
  if (!encodedParameters) {
    return "";
  }

  return (
    encodedParameters
      // Reverse '%' replacement
      .replace(/--/g, "%")
      // Reverse '=' replacement
      .replace(/__/g, "=")
      // Reverse '&' replacement
      .replace(/-/g, "&")
      // Reverse '_' replacement
      .replace(/%5F/g, "_")
      // Reverse '-' replacement
      .replace(/%2D/g, "-")
      // Reverse '.' replacement
      .replace(/%2E/g, ".")
  );
}
